import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Globals} from '.././globals';

@Injectable()
export class DiscoverService {

  user:any;
  reqHeader = new HttpHeaders({ 'No-Auth':'True'});

 constructor(private http: HttpClient,private _global:Globals) {
     
 }
 readonly rootUrl = this._global.siteUrl;



 getDiscoverPeopel(obj){
    return this.http.post(this.rootUrl + 'forums/getdiscoverpeopel',obj,{ headers: this.reqHeader});  }

 
}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/service/discover.service.ts